/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Coach_Extra_Conversation_DatedInputs */

const en_us2_coach_extra_conversation_dated = /** @type {(inputs: Coach_Extra_Conversation_DatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversation from ${i?.date}`)
};

const pt_br2_coach_extra_conversation_dated = /** @type {(inputs: Coach_Extra_Conversation_DatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversa de ${i?.date}`)
};

const es_419_coach_extra_conversation_dated = /** @type {(inputs: Coach_Extra_Conversation_DatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversación del ${i?.date}`)
};

const pt_pt2_coach_extra_conversation_dated = /** @type {(inputs: Coach_Extra_Conversation_DatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversa de ${i?.date}`)
};

const fr_fr2_coach_extra_conversation_dated = /** @type {(inputs: Coach_Extra_Conversation_DatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversation du ${i?.date}`)
};

const de_de2_coach_extra_conversation_dated = /** @type {(inputs: Coach_Extra_Conversation_DatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unterhaltung vom ${i?.date}`)
};

const it_it2_coach_extra_conversation_dated = /** @type {(inputs: Coach_Extra_Conversation_DatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conversazione del ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Conversation from {date}" |
*
* @param {Coach_Extra_Conversation_DatedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_conversation_dated = /** @type {((inputs: Coach_Extra_Conversation_DatedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Conversation_DatedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_conversation_dated(inputs)
	if (locale === "es-419") return es_419_coach_extra_conversation_dated(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_conversation_dated(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_conversation_dated(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_conversation_dated(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_conversation_dated(inputs)
	return en_us2_coach_extra_conversation_dated(inputs)
});
export { coach_extra_conversation_dated as "coach-extra.conversation_dated" }